import { Injectable } from '@tanbo/vue-di-plugin'
export interface OrderOption {
  execute_type: number,
  device_list: string[],
  group_id: number,
  is_repair: boolean
}

export interface ExaminationDetail {
  garbage: { [key: string]: string },
  speed: { [key: string]: string },
  guard: { [key: string]: string },
  system: { [key: string]: string },
  soft: { [key: string]: string },
  virus: { [key: string]: string },
}

@Injectable()
export abstract class ExaminationDetailService {
  abstract fetchExaminationDetails (deviceId: string): Promise<ExaminationDetail>;

  abstract repairTerminal (option: OrderOption): Promise<void>
}
